export const RESET_APP = "RESET_APP";

// Action creator for resetting the app state
export const resetApp = () => ({
  type: RESET_APP,
});
